var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 43,
    viewBox: "0 0 68 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3813_2371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94167 1.40625H58.0572C60.1584 1.40625 61.8622 3.10313 61.8622 5.19594V37.1161H6.13672V5.19594C6.13672 3.10313 7.84043 1.40625 9.94167 1.40625Z",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4931 41.5941H6.50595C3.14113 41.5941 1.4043 39.1949 1.4043 37.5734V37.1162H66.5948V37.5734C66.5948 39.1949 64.91 41.5941 61.4931 41.5941Z",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2031 39.3555H39.1414",
    stroke: "#313131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5069 18.6953L43.6435 30.8396C43.4646 31.4003 42.9579 31.7823 42.3855 31.7823H25.6145C25.0421 31.7823 24.5354 31.4003 24.3565 30.8396L20.4932 18.6953",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4505 15.8916H20.5492C20.0037 15.8916 19.5615 16.3745 19.5615 16.9702V17.6174C19.5615 18.213 20.0037 18.6959 20.5492 18.6959H47.4505C47.996 18.6959 48.4382 18.213 48.4382 17.6174V16.9702C48.4382 16.3745 47.996 15.8916 47.4505 15.8916Z",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6348 15.9475L31.3269 8.41309",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7097 15.9475L37.0176 8.41309",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4658 21.5V28.9783",
    stroke: "#1EC95B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0546 20.5654L39.123 28.9785",
    stroke: "#1EC95B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9453 20.5654L28.8768 28.9785",
    stroke: "#1EC95B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3813_2371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 43,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.fc130d442e214412cfc1fd463e448d4c.svg";
export { ForwardRef as ReactComponent };